import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Button, Col, Row, Spinner, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Confirm from "../Confirm";
import PaymentEdit from "./PaymentEdit";
import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import { formatDate,formatDateForView, getUserDetails } from '../../utils/helper';
import PERMISSIONS from "../../constants/permissions";
const PaymentRelatedList = ({
  parent,
  refreshPaymentList,
  onPaymentListUpdate,
  parentsubmitpayments,
  pendingAmount,
}) => {
  const userInfo = getUserDetails();
  const [modalShow, setModalShow] = React.useState(false);
  const [payment, setPayment] = React.useState("");
  const [modalShowpayment, setModalShowpayment] = React.useState(false);
  const [modalShowpaymentView, setModalShowpaymentView] = React.useState(false);

  const [body, setBody] = useState([]);

  useEffect(() => {
    paymentList();
  }, [refreshPaymentList]);

  const paymentList = () => {
    async function init() {
      let payments = await fuziElevatorsApi.fetchPayments(parent.id);
      //console.log('payments',payments)
      //console.log(payments);
      if (payments && payments?.length > 0) {
        setBody(payments);
        let total = 0;
        payments.map((item) => {
          total += parseFloat(item.amount);
        });
        onPaymentListUpdate(total);
      } else {
        setBody([]);
        onPaymentListUpdate(0);
      }
    }
    init();
  };
  const handleDelete = (row) => {
    setModalShow(true);
    setPayment(row);
  };

  const labels = {
    beforeSelect: " ",
  };

  const deletepayment = async () => {
    const result = await fuziElevatorsApi.deletePayment(payment.id);
    //console.log('result',result)
    if (result.success) {
      setPayment("");
      setModalShow(false);
      paymentList();
      parentsubmitpayments(); //Added by shivani 7 aug
    }
  };

  const submitpayments = () => {
    setModalShowpayment(false);
    paymentList();
    parentsubmitpayments(); //Added by shivani 7 aug
  };

  const editPayment = (row) => {
    setModalShowpayment(true);
    setPayment(row);
  };
  {/* Added by Imran Khan Payment Service on AMC Ticket 1064 on 16-March-2026*/}
  const header = [
    {
      title: "Amount",
      prop: "amount",
      cell: (row) => (
        <Link onClick={() => editPayment({ row })}>₹ {row.amount}</Link>
      ),
    },
    //formatDateForView added by shahir hussain 27-08-2025
    {
      title: "Payment Date",
      prop: "paymentdate",
      cell: (row) => (row.paymentdate ? formatDateForView(row.paymentdate) : ''),
    },
    { title: "Payment Mode", prop: "type" },
    { title: "Service Type", prop: "payment_service"},
    { title: "Remark", prop: "discription" },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <>
          {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_PAYMENT].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
          }) && (
              <Button className="btn-sm mx-2" onClick={() => editPayment({ row })}>
                <i className="fa-regular fa-pen-to-square"></i>
              </Button>
            )}
          {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_PAYMENT].some(permission => {
            return userInfo?.permissions?.map(p => p.name).includes(permission);
          }) && ( 
            <>
              <Button
                className="btn-sm mx-2"
                variant="danger"
                onClick={() => handleDelete(row)}
              >
                <i class="fa-regular fa-trash-can"></i>
              </Button>
            </>
          )}
        </>
      ),
    },
  ];

  return (
    <>
      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deletepayment={deletepayment}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="payment"
        />
      )}
      {modalShowpayment && (
        <PaymentEdit
          show={modalShowpayment}
          onHide={() => setModalShowpayment(false)}
          parentid={parent.id}
          payment={payment}
          table="lead"
          submitpayments={submitpayments} //Added by shivani 7 aug
          pendingAmount={pendingAmount} //Added by shivani 7 aug */
        />
      )}

      {body ? (
        <DatatableWrapper
          body={body}
          headers={header}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 5,
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            ></Col>
          </Row>
          <Table striped className="related-list-table shadow rounded sm" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {(body && Array.isArray(body)) ?
                        <TableBody />
                        :
                        <tbody className="">
                            <tr>
                                <td colSpan={100} align="center">
                                    <div>
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    }
                </Table>
          <Pagination
            classes={{
              buttonGroup: "btn-custom",
              button: "bg-custom border-white",
            }}
          />
        </DatatableWrapper>
      ) : (
        ""
      )}
    </>
  );
};

export default PaymentRelatedList;
